import React from "react";
import _ from "lodash";
import longBorder from "assets/images/flus/long-border.png";
import longBorder2 from "assets/images/flus/long-border2.png";
import { motion } from "framer-motion/dist/framer-motion";
import {
  divVariants,
  fadeVariants,
  staticBounceVariants
} from "shared/components/animations";

const FlusterTopPlayer = ({
  rightPlayer = {},
  words = "",
  leftPlayer = {},
  description = "",
  rightBottomText = "",
  leftBottomText = "",
  leftBoldBottomText = "",
  rightBoldBottomText = "",
  isShowBottamText = false,
  isAroundTheHornResult = false,

  ready_to_vote
}) => {
  return (
    <>
      <div className={`long-border ${isShowBottamText ? "long-border2" : ""}`}>
        <img
          src={isShowBottamText ? longBorder : longBorder2}
          className="img-fluid"
          alt=""
        />
      </div>

      {_.isEmpty(rightPlayer) ? (
        <div className="top-game-asker">
          <div className="text-center player-div">
            <motion.p variants={fadeVariants} className="name">
              {leftPlayer?.display_name}
            </motion.p>
            <motion.div
              variants={staticBounceVariants}
              className="player-border"
            >
              <img
                src={leftPlayer?.profile_image}
                className="img-fluid image"
                alt=""
              />
            </motion.div>
          </div>
          <div className="text-div">
            <motion.p variants={fadeVariants} className="info">
              {words}
            </motion.p>
            <motion.p variants={fadeVariants} className="info2">
              {description}
            </motion.p>
          </div>
        </div>
      ) : (
        <div className={`answeres ${isShowBottamText ? "bottam-text" : ""}`}>
          <div className="text-center player-div">
            <motion.p
              variants={ready_to_vote ? {} : fadeVariants}
              className="name"
            >
              {leftPlayer?.display_name}
            </motion.p>
            <motion.div
              variants={ready_to_vote ? {} : staticBounceVariants}
              className="player-border"
            >
              <img
                src={leftPlayer?.profile_image}
                className="img-fluid image"
                alt=""
              />
            </motion.div>
            {isShowBottamText && (
              <motion.div
                variants={fadeVariants}
                className="text-left small-big-text"
              >
                <p className="small">{leftBottomText}</p>
                <p className="big ">{leftBoldBottomText}</p>
              </motion.div>
            )}
          </div>
          <motion.p variants={fadeVariants} className="text">
            {words}
          </motion.p>

          <div className="text-center player-div">
            <motion.p variants={fadeVariants} className="name">
              {rightPlayer?.display_name}
            </motion.p>
            <motion.div
              variants={staticBounceVariants}
              className="player-border"
            >
              <img
                src={rightPlayer?.profile_image}
                className="img-fluid image"
                alt=""
              />
            </motion.div>
            {isShowBottamText && (
              <motion.div
                variants={fadeVariants}
                className={`small-big-text ${
                  isAroundTheHornResult ? " small-big-text2" : "flus"
                }`}
              >
                <p className="small">{rightBottomText}</p>
                <p className="big">{rightBoldBottomText}</p>
              </motion.div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default FlusterTopPlayer;
